import TutorialItem from './TutorialItem'

//imported and rendered on pages/tutorials.js
export default function TutorialList(props) {
    return(
        <>
            {props.tutorials.map(tutorial => (<TutorialItem key={tutorial.id} tutorial={tutorial} />))}
        </>
    )
}